import React, { FC } from 'react'
import { NumberFormatValues, NumericFormat } from 'react-number-format'
import { BtInputBase, BtInputBaseProps } from './BtInputBase'

export interface BtCurrencyInputProps extends BtInputBaseProps {}

export const BtCurrencyInput: FC<BtCurrencyInputProps> = ({
  size,
  value,
  label,
  required,
  disabled,
  placeholder,
  onChangeText,
  testID,
  maxLength,
}) => {
  const handleValueChange = (formatValues: NumberFormatValues) => {
    if (onChangeText) {
      onChangeText(formatValues.value)
    }
  }

  return (
    <NumericFormat
      prefix="$"
      size={size}
      value={value}
      label={label}
      decimalScale={2}
      required={required}
      disabled={disabled}
      allowNegative={false}
      keyboardType="number-pad"
      customInput={BtInputBase}
      placeholder={placeholder}
      onValueChange={handleValueChange}
      testID={testID}
      valueIsNumericString
      thousandSeparator
      maxLength={maxLength}
    />
  )
}
